import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext.js";

const PrivateRoute = ({ children, requiredRole }) => {
  const { currentUser, userRole } = useAuth();

  if (!currentUser) {
    // Redirige a la página de inicio de sesión si no hay usuario autenticado
    return <Navigate to="/login" />;
  }

  if (requiredRole && userRole !== requiredRole) {
    // Redirige a "No autorizado" si el usuario no tiene el rol requerido
    return <Navigate to="/unauthorized" />;
  }

  // Renderiza el contenido si pasa las verificaciones
  return children;
};

export default PrivateRoute;
